import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionsListView';
import { AppState } from '../../../../../types/store';
import {
  setCurrentlyViewedFolderId,
  addFolderToFullViewList,
} from '../../../../actions/gallectionSection';
import {
  getOrderedNonEmptyFolders,
  getFolderById,
} from '../../../../selectors/folders';
import {
  getFullViewFolderIds,
  hasMoreDeviationsInLastFullViewFolder,
  isFetchingPausedInLastFullViewFolder,
  getCurrentlyViewedFolderId,
  getGallectionSectionType,
} from '../../../../selectors/gallectionSection';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';

export type StateProps = Pick<
  Props,
  | 'folders'
  | 'fullViewFolderIds'
  | 'currentFolder'
  | 'hasMoreDeviationsInLastFullViewFolder'
  | 'isFetchingPausedInLastFullViewFolder'
>;
export type DispatchProps = Pick<
  Props,
  'setCurrentlyViewedFolderId' | 'addFolderToFullViewList'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const currentlyViewedFolderId = getCurrentlyViewedFolderId(state);
  return {
    folders: getOrderedNonEmptyFolders(state),
    fullViewFolderIds: getFullViewFolderIds(state),
    currentFolder: currentlyViewedFolderId
      ? getFolderById(
          state,
          getGallectionSectionType(state),
          currentlyViewedFolderId
        )
      : undefined,
    hasMoreDeviationsInLastFullViewFolder: hasMoreDeviationsInLastFullViewFolder(
      state
    ),
    isFetchingPausedInLastFullViewFolder: isFetchingPausedInLastFullViewFolder(
      state
    ),
    isRedesigned: flagEnabled(state, 'little_gallery_redesign'),
    forceDesktopFolderDropdown: flagEnabled(
      state,
      'force_desktop_folder_dropdown'
    ),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setCurrentlyViewedFolderId,
  addFolderToFullViewList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
